[
  {
    "id": 1,
    "image": "/assets/redesign/insights/download_image.png",
    "text": "BEHAVIORAL INTELLIGENCE: BUILDING TRUST & CHARGING FORWARD",
    "buttonText": "Download"
  }
]
